
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AnimateValue',
    props: {
        value: {
            type: [Number, String, Boolean],
            required: true,
        },
    },
});
